import { useQuery } from "@tanstack/react-query"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getCityWarLeaderboard, getLeagueBalance } from "@/api/gameApi"

export default function WarDashboardPage() {
  const warQ = useQuery({
    queryKey: ["city-war-lb"],
    queryFn: getCityWarLeaderboard,
  })

  const balanceQ = useQuery({
    queryKey: ["league-balance"],
    queryFn: getLeagueBalance,
  })

  return (
    <GameScreenLayout title="Война городов" backTo="/play">
      {balanceQ.data ? (
        <p className="mb-4 text-sm text-guardians-muted">
          Баланс лиг: TITAN {balanceQ.data.titanPercent}% / ATLANT{" "}
          {balanceQ.data.atlantPercent}%
        </p>
      ) : null}

      {warQ.isLoading ? (
        <p className="text-sm text-guardians-muted">Рейтинг войны…</p>
      ) : (
        <ol className="space-y-1 text-sm">
          {(warQ.data?.entries ?? []).slice(0, 30).map((e) => (
            <li key={e.rank} className="flex justify-between">
              <span>
                {e.rank}. {e.cityName ?? e.nickname}
              </span>
              <span className="text-guardians-accent">{e.warPts ?? e.pts}</span>
            </li>
          ))}
        </ol>
      )}
    </GameScreenLayout>
  )
}
